import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { permissions, meta } from 'helpers/decorators'
import { Modal, Export } from 'containers/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { FilterTasksRegistrationAwardUnits } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { Status, ButtonGroup, Button } from 'components/misc'
import { AwardUnitDetailModal, GOPAssignmentModal } from 'components/modals'
import {
  apiTasksRegistrationAwardUnits,
  apiOrganizations,
  apiConfiguration
} from 'helpers/decorators/api'
import { tasks as tasksLayout } from 'constants/layout'
import MODALS from 'constants/modals'
import { modal } from 'redux/modules/app'
import { FormattedDate } from '../../../components/intl'
import { CONFIGURATION_KEYS, ROLES } from '../../../constants/enums'

const enhance = compose(
  meta({
    title: 'Registration',
    intlKey: 'pageTitle.registrations',
    dynamicProp: 'organizations.detail.name'
  }),
  permissions(),
  apiConfiguration({
        getValues: [
            CONFIGURATION_KEYS.isGOPEnabled.id
        ]
    }),
  apiTasksRegistrationAwardUnits({
    tasks: true
  }),
  apiOrganizations({
    updateTasks: true
  }),
  connect(({ auth }) => ({
      activeOrganization: auth.organization
  }), { modal })
)

class RegistrationAwardUnits extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    exportAwardUnitsRegistrations: PropTypes.func.isRequired,
    setTasksAwardUnitsParams: PropTypes.func,
    approveAwardUnit: PropTypes.func.isRequired,
    returnAwardUnit: PropTypes.func.isRequired,
    disablePersistedFilter: PropTypes.bool,
    permissions: PropTypes.object,
    activeOrganization: PropTypes.object.isRequired,
    configuration: PropTypes.object
  }

  state = {
    awardUnitApproveId: null,
    awardUnitReturnId: null,
    orgId: null,
    awardUnitData: {}
  }

  handleApproveUnitModal = awardUnitApproveId =>
    this.setState({ awardUnitApproveId }, () => {
      this.props.modal('modal-unit-approve')
    })

    handleGOPAssignmentModal = (awardUnitApproveId, orgId) =>
        this.setState({ awardUnitApproveId, orgId }, () => {
            this.props.modal(MODALS.GOP_ASSIGNMENT_MODAL)
        })


    handleReturnUnitModal = awardUnitReturnId =>
    this.setState({ awardUnitReturnId }, () => {
      this.props.modal('modal-unit-return')
    })

  handleShowUnitDetails = awardUnitData => {
    this.setState(
      {
        awardUnitData
      },
      () => {
        this.props.modal(MODALS.AWARD_UNIT_DETAIL)
      }
    )
  }

  render() {
    const {
      tasks: {
        registrationAwardUnits: { loading, list, offset, limit, pages, sort }
      },
      setTasksAwardUnitsParams,
      approveAwardUnit,
      returnAwardUnit,
      disablePersistedFilter,
        activeOrganization,
        configuration,
        permissions: appPermission
    } = this.props

     const isLoading = get(this.props, "organizations.loading")

      const isGOPEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.isGOPEnabled.id}].booleanValue`)

      const showAssignGOP = (appPermission.activeRole === ROLES.IF_STAFF_SUPER.u || appPermission.activeRole === ROLES.GBT.u) && isGOPEnabled

      const ExportComponent = (
      <Export
        exportName="AwardUnitsRegistrations"
        toExport={this.props.exportAwardUnitsRegistrations}
        exportSchemeValue="registrations-award-units"
        count={this.props.tasks && this.props.tasks.count}
      />
    )

    return (
      <div>
        <FilterTasksRegistrationAwardUnits
          disablePersistedFilter={disablePersistedFilter}
        />
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.awardUnitsTableHeaders}
          setParams={setTasksAwardUnitsParams}
          exportComponent={ExportComponent}
        >
          <Data>
            {list.map(({ awardUnitRegistration }) => (

              <tr key={get(awardUnitRegistration, 'id')}>
                <td>
                  <span
                    className="link"
                    onClick={() =>
                      this.handleShowUnitDetails(awardUnitRegistration)}
                  >
                    {get(awardUnitRegistration, 'organization.name')}
                  </span>
                </td>
                  <td>
                      <FormattedDate value={get(awardUnitRegistration, 'creationDate')} />
                  </td>
                <td>
                  <Status
                    state={get(awardUnitRegistration, 'alreadyRunningAward')}
                    check
                  />
                </td>
                <td>
                  {get(awardUnitRegistration, 'firstName') || '---'}{' '}
                  {get(awardUnitRegistration, 'lastName')}
                </td>
                <td>{get(awardUnitRegistration, 'email') || '---'}</td>
                <td>{get(awardUnitRegistration, 'phoneNumber')}</td>
                <td>
                  {get(
                    awardUnitRegistration,
                    'awardLeaderRegistration.isCoordinator'
                  ) &&
                    `${get(awardUnitRegistration, 'awardLeaderRegistration.firstName')} ${get(awardUnitRegistration, 'awardLeaderRegistration.middleName') || ''} ${get(awardUnitRegistration, 'awardLeaderRegistration.lastName')}`}
                  <br />
                  <small>
                    {get(
                      awardUnitRegistration,
                      'awardLeaderRegistration.email'
                    )}
                  </small>
                </td>
                <td>
                  <ButtonGroup>
                      {!get(awardUnitRegistration, 'globalOperatingPartnerId') && showAssignGOP && <Button
                          tiny
                          onClick={() =>
                              this.handleGOPAssignmentModal(
                                  get(awardUnitRegistration, 'id'),
                                  get(awardUnitRegistration, 'organization.id')
                              )}
                          intlKey="button.gop_assignment"
                      >
                          GOP Assignment
                      </Button>}
                    <Button
                      tiny
                      onClick={() =>
                        this.handleApproveUnitModal(
                          get(awardUnitRegistration, 'id')
                        )}
                      intlKey="button.approve"
                    >
                      Approve
                    </Button>
                    <Button
                      tiny
                      onClick={() =>
                        this.handleReturnUnitModal(
                          get(awardUnitRegistration, 'id')
                        )}
                      intlKey="button.delete"
                      secondary
                    >
                      Delete
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id="modal-unit-approve" customActions>
          <TaskApprove
            approve={approveAwardUnit}
            id={this.state.awardUnitApproveId}
            modal={this.props.modal}
            isLoading={isLoading}
            title="Approve registration"
            intlKey="tasks.approve_registration"
          />
        </Modal>
        <Modal id="modal-unit-return" customActions>
          <TaskReturn
            returnTask={returnAwardUnit}
            id={this.state.awardUnitReturnId}
            modal={this.props.modal}
            title="Delete registration"
            intlKey="tasks.delete_registration"
            noNote
            ctaIntlKey="button.delete"
          />
        </Modal>
        <AwardUnitDetailModal
          modalId={MODALS.AWARD_UNIT_DETAIL}
          data={this.state.awardUnitData}
          modal={this.props.modal}
        />
          <GOPAssignmentModal
              modalId={MODALS.GOP_ASSIGNMENT_MODAL}
              modal={this.props.modal}
              awardUnitRegistrationId={this.state.awardUnitApproveId}
              orgId={this.state.orgId}
          />
      </div>
    )
  }
}

export default enhance(RegistrationAwardUnits)
